import Skeleton from '@components/v2/ui/Skeleton/Skeleton';
import { Stack } from '@mui/material';
import useMeasuredWidth from '../../../../../../hooks/useMeasuredWidth';
import useGeneralSettingsStore from '../../../../../../stores/GeneralSettings/useGeneralSettingsStore';
import configureGridItemWidth from '../../../../../../utils/configureGridItemsWidth';
import { useOrderProductsLayoutContext } from '../../../../contexts/OrderProductsLayout.context';
import { getGridSpacing } from '../../grid/components/components/HorizontalScroll/HorizontalScroll.styles';
import {
  SKELETON_GRID_BUTTON_GAP,
  SKELETON_GRID_BUTTON_HEIGHT,
  SKELETON_GRID_BUTTON_WIDTH,
  SKELETON_GRID_CELL_HEIGHT,
  SKELETON_GRID_CELL_TOUCH_HEIGHT,
  SKELETON_GRID_FALLBACK_WIDTH,
  SKELETON_SURFACE_SX,
} from './orderProductItemSkeleton.constants';

const OrderProductGridSkeleton = () => {
  const { hasTouchGrid } = useOrderProductsLayoutContext();
  const {
    generalSettings: { gridSize },
  } = useGeneralSettingsStore();
  const { containerRef, width: availableWidth } = useMeasuredWidth(SKELETON_GRID_FALLBACK_WIDTH);

  const cellGap = getGridSpacing(hasTouchGrid);
  const cellWidth = configureGridItemWidth(gridSize);
  const cellHeight = hasTouchGrid ? SKELETON_GRID_CELL_TOUCH_HEIGHT : SKELETON_GRID_CELL_HEIGHT;
  const columns = Math.max(1, Math.ceil(availableWidth / (cellWidth + cellGap)));

  return (
    <Stack
      aria-hidden
      direction="row"
      sx={{ alignItems: 'center', columnGap: `${SKELETON_GRID_BUTTON_GAP}px` }}
    >
      <Stack
        ref={containerRef}
        direction="row"
        sx={{ flex: 1, minWidth: 0, overflow: 'hidden', columnGap: `${cellGap}px` }}
      >
        {Array.from({ length: columns }, (_, column) => (
          <Skeleton
            key={column}
            variant="rounded"
            width={cellWidth}
            height={cellHeight}
            sx={{ ...SKELETON_SURFACE_SX, flexShrink: 0 }}
          />
        ))}
      </Stack>

      <Skeleton
        variant="rounded"
        width={SKELETON_GRID_BUTTON_WIDTH}
        height={SKELETON_GRID_BUTTON_HEIGHT}
        sx={{ ...SKELETON_SURFACE_SX, flexShrink: 0 }}
      />
    </Stack>
  );
};

export default OrderProductGridSkeleton;
